import {LABELS_EN} from "@labels/en/labelsEn";
import {LABELS_UK} from "@labels/uk/labelsUk";
import {getCookie} from "@helpers/cookie/cookie";
import {initReactI18next} from "react-i18next";
import i18next from "i18next";

const cookieLang = getCookie('language')

const translationsArray = ['uk', 'en'];

const lang = translationsArray.find((lang) => {
    return lang === cookieLang;
}) ?? 'uk';


i18next
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {translation: LABELS_EN},
            uk: {translation: LABELS_UK},
        },
        lng: lang,
        fallbackLng: 'uk',
        interpolation: {escapeValue: false},
    });

